import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(({ spacing, palette }) => ({
  productInfo: {
    color: palette.contrastText.main,
    lineHeight: 1.5,
  },
  avatar: {
    borderRadius: spacing(1),
  },
  leftPart: {
    maxWidth: "15%",
    width: 15,
  },
  listElement: {
    padding: spacing(1),
    borderBottom: `1px solid ${palette.separator.main}`,
  },
  icon: {
    verticalAlign: "middle",
    display: "inline-block",
  },
  productName: {
    width: "100%",
    color: palette.contrastText.main,
    lineHeight: 1.5,
    fontSize: "14px",
    minWidth: 0,
    maxWidth: "80%",
  },
}));

export default styles;
